import React, {Component} from 'react';

import '../../Frontpage.css';

import '../../common_styles/table.css'
import {
    addToCompanyWhitelist,
    deleteCustomerFromCompany,
    getCompanyWhitelist,
    getUsersByCompany
} from "../../operations/fetch";
import {Button} from "jjfw";

export default class Users extends Component {

    constructor(props) {
        super(props);

        this.state = {
            cognitoToken: this.props.accessToken,
            users: [],
            whitelist: [],
            email: ""
        };

        this.getUsers()
    }

    async getUsers() {
        this.setState({
            users: await getUsersByCompany(this.state.cognitoToken),
            whitelist: await getCompanyWhitelist(this.state.cognitoToken)
        });
    }

    render() {

        return (
            <div>
                <div style={{float: "left", padding: 10, margin: 25, backgroundColor: "white", border: "1px solid lightgrey", display: "inline-block", width: 1200}}>
                    <div style={{width: "100%", height: 40, borderBottom: "1px solid black", fontSize: 20}}>
                        Users</div>
                    <header style={{float: "left"}}>
                        <br />
                        <table className="ar-table">
                            <thead>
                            <tr>
                                <th>Email</th>
                                <th>Register Date</th>
                                <th>Relation</th>
                                <th>Remove from company</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderUsers()}
                            </tbody>
                        </table>
                    </header>
                    <header style={{float: "left", marginLeft: 25}}>
                        <br />
                        <table className="ar-table">
                            <thead>
                            <tr>
                                <th>Whitelisted Emails</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderWhitelist()}
                            </tbody>
                        </table>
                        <br />
                        <table className="ar-table">
                            <thead>
                            <tr>
                                <th>Email</th>
                                <th>Add</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><input value={this.state.email}
                                           onChange={(e) => this.setState({email: e.target.value})}/>
                                </td>
                                <td>
                                    <Button text="Add Email" function={async () => {
                                        await addToCompanyWhitelist({
                                            email: this.state.email,
                                            cognitoToken: this.state.cognitoToken
                                        });
                                        await this.getUsers();
                                    }}/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </header>
                </div>
            </div>
        );
    }

    renderUsers() {
        console.log(this.state.users)
        return (this.state.users.map((user) =>
            <tr>
                <td>{user.email}</td>
                <td>{user.register_date}</td>
                <td>{user.relation}</td>
                <td><Button text="Remove" function={async () => {
                    await deleteCustomerFromCompany(user.id, this.state.cognitoToken);
                    await this.getUsers();
                }}/></td>
            </tr>
        ))
    }

    renderWhitelist() {
        return (this.state.whitelist.map((user) =>
            <tr>
                <td>{user.email}</td>
            </tr>
        ))
    }
}
